"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITGExecutionTransformation = void 0;
var common_1 = require("../model/common");
var Transformation_1 = require("./Transformation");
var channel_1 = require("../event/channel");
var custom_validation_service_1 = require("./../services/custom_validation.service");
var itgConfig_model_1 = require("../model/itgConfig.model");
var ITGExecutionTransformation = (function (_super) {
    __extends(ITGExecutionTransformation, _super);
    function ITGExecutionTransformation(config) {
        var _this = _super.call(this, config) || this;
        _this.config = config;
        return _this;
    }
    ITGExecutionTransformation.prototype.tranformTemplateResponse = function (request, templateRequest) {
        var errorMessage = this.validateSdkRequest(request, templateRequest);
        if (errorMessage && errorMessage.errors && errorMessage.errors.length > 0) {
            return new Promise(function (resolve) {
                return resolve(errorMessage);
            });
        }
        else {
            this.transformEnDeCryptedField(request);
        }
        request.url = this.transformUrl(request);
        return this.processConsumerDataAndHTML([this.loadTemplate.get(templateRequest), this.getExecutionData(request)], request);
    };
    ITGExecutionTransformation.prototype.tranformTemplateString = function (request, templateString) {
        if (typeof templateString !== 'string') {
            var responseData_1 = {
                html: '',
                errors: [
                    {
                        statusCode: common_1.NULL_REQUEST,
                        messages: [common_1.NULL_REQUEST_MSG],
                    },
                ],
            };
            return new Promise(function (resolve) {
                return resolve(responseData_1);
            });
        }
        this.transformEnDeCryptedField(request);
        request.url = this.transformUrl(request);
        return this.processConsumerDataAndHTML([this.getExecutionData(request)], request, templateString);
    };
    ITGExecutionTransformation.prototype.processConsumerDataAndHTML = function (requestParams, request, templateString) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Promise.all(requestParams)
                .then(function (data) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                var responseData = Object.assign({});
                var htmlResponse = templateString ? templateString : data[0].html;
                var dataReceived = templateString ? data[0] : data[1];
                var serviceCallResponse = dataReceived;
                var isExit = ((_a = dataReceived.data) === null || _a === void 0 ? void 0 : _a.exit) ? (_b = dataReceived.data) === null || _b === void 0 ? void 0 : _b.exit : false;
                var workLog = (_c = dataReceived.data) === null || _c === void 0 ? void 0 : _c.flowStepResult;
                var errorMessage;
                var metaData = Object.assign({});
                _this.getMetadata(metaData, serviceCallResponse);
                if (!templateString && htmlResponse && htmlResponse.error) {
                    errorMessage = htmlResponse.error;
                }
                else if (serviceCallResponse && serviceCallResponse.error) {
                    errorMessage = serviceCallResponse.error;
                }
                else {
                    errorMessage = _this.validateServiceResponse(serviceCallResponse.data);
                }
                responseData.metaData = metaData;
                responseData.backendServiceLog = {
                    Request: JSON.stringify(request.query),
                    Response: JSON.stringify(serviceCallResponse),
                };
                if (errorMessage && !(((_d = serviceCallResponse === null || serviceCallResponse === void 0 ? void 0 : serviceCallResponse.data) === null || _d === void 0 ? void 0 : _d.hasOwnProperty('pageElements')) && _this.returnHTMLOnError)) {
                    responseData.html = '';
                    responseData.errors = [];
                    (_e = responseData.errors) === null || _e === void 0 ? void 0 : _e.push(errorMessage);
                    responseData.isExit = isExit;
                    responseData.workLog = workLog;
                    resolve(responseData);
                    return;
                }
                if ((_f = serviceCallResponse.data) === null || _f === void 0 ? void 0 : _f.sessionId) {
                    custom_validation_service_1.customValidateFuntionArray.sessionId = (_g = serviceCallResponse.data) === null || _g === void 0 ? void 0 : _g.sessionId;
                }
                _this.serviceCallResponseData = serviceCallResponse.data;
                try {
                    var modifiedTemplateResponse = _this.domParsing.init(htmlResponse, serviceCallResponse.data);
                    responseData.html = modifiedTemplateResponse.html ? modifiedTemplateResponse.html : '';
                    responseData.errors = modifiedTemplateResponse.error ? [modifiedTemplateResponse.error] : undefined;
                    responseData.isExit = isExit;
                    responseData.workLog = workLog;
                    if (errorMessage && ((_h = serviceCallResponse === null || serviceCallResponse === void 0 ? void 0 : serviceCallResponse.data) === null || _h === void 0 ? void 0 : _h.hasOwnProperty('pageElements')) && _this.returnHTMLOnError) {
                        if (responseData.errors !== undefined) {
                            (_j = responseData.errors) === null || _j === void 0 ? void 0 : _j.push(errorMessage);
                        }
                        else {
                            responseData.errors = [errorMessage];
                        }
                    }
                    resolve(responseData);
                    return;
                }
                catch (err) {
                    var domParsingError = _this.errorValidation.getDomParsingError();
                    resolve(domParsingError);
                    return;
                }
            })
                .catch(function (err) {
                console.log('transform error', err);
                reject(err);
            });
        });
    };
    ITGExecutionTransformation.prototype.getMetadata = function (metadata, serviceCallResponse) {
        var _a, _b, _c, _d, _e, _f;
        metadata.sessionId = ((_a = serviceCallResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) || '';
        metadata.itgName = ((_b = serviceCallResponse.data) === null || _b === void 0 ? void 0 : _b.itgName) || '';
        if (serviceCallResponse.data && serviceCallResponse.data.stepId !== undefined) {
            metadata.stepId = ((_c = serviceCallResponse.data) === null || _c === void 0 ? void 0 : _c.stepId) || '';
        }
        else {
            metadata.stepId = ((_d = serviceCallResponse.data) === null || _d === void 0 ? void 0 : _d.pathIds) || '';
        }
        if (serviceCallResponse.data && serviceCallResponse.data.stepName !== undefined) {
            metadata.stepName = ((_e = serviceCallResponse.data) === null || _e === void 0 ? void 0 : _e.stepName) || '';
        }
        else {
            metadata.stepName = ((_f = serviceCallResponse.data) === null || _f === void 0 ? void 0 : _f.stepNames) || '';
        }
        if (serviceCallResponse.data && serviceCallResponse.data.hasOwnProperty('pageName')) {
            var genericData = serviceCallResponse.data;
            metadata.pageName = genericData.pageName || '';
        }
    };
    ITGExecutionTransformation.prototype.transformUrl = function (request) {
        if (!request.url) {
            var url = '';
            var uri = '';
            url = this.config.URL || itgConfig_model_1.ItgURL;
            if (request.query && request.query.stepId) {
                uri = this.config.stepItgURI || itgConfig_model_1.stepItgURI;
            }
            else {
                uri = this.config.startItgURI || itgConfig_model_1.startItgURI;
            }
            return url + uri;
        }
        else {
            return request.url;
        }
    };
    ITGExecutionTransformation.prototype.getDeCrypteddVal = function (val, key) {
        var session = key || custom_validation_service_1.customValidateFuntionArray.sessionId;
        var deCrypteddVal;
        if (val && typeof val === 'string') {
            var splitVal = val.match('\\{(.*)\\}');
            if (splitVal) {
                var encryptedVal = val.replace(splitVal[0], '');
                deCrypteddVal = this.encryptAndDecrypt.enCryptDeCryptValue(encryptedVal, session, false);
            }
        }
        return deCrypteddVal;
    };
    ITGExecutionTransformation.prototype.bindEvent = function () {
        this.bindingEvent.init(this.serviceCallResponseData, this.getFormData, this);
    };
    ITGExecutionTransformation.prototype.getFormData = function (data, sdk) {
        var finalData = Object.assign({
            sessionId: sdk.serviceCallResponseData.sessionId,
            stepId: sdk.serviceCallResponseData.stepId,
            displayFormReferenceKey: data.formName.target.getAttribute('rsactionoriginatorkey'),
        });
        this.returnHTMLOnError = sdk.returnHTMLOnError;
        var finalDataRequest = __assign(__assign({}, finalData), data);
        sdk.eventbus.publish(channel_1.ITG_RENDER_CHANNEL, finalDataRequest);
    };
    ITGExecutionTransformation.prototype.getExecutionData = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var responseData, err_1, responseData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 5]);
                        _a = {};
                        return [4, this.restClient.generic(request)];
                    case 1:
                        responseData = (_a.data = _b.sent(),
                            _a);
                        return [4, responseData];
                    case 2: return [2, _b.sent()];
                    case 3:
                        err_1 = _b.sent();
                        console.log('getItgExecutionData Error', err_1);
                        responseData = {
                            error: {
                                messages: err_1.message,
                                statusCode: common_1.HTTP_ERROR_CODE,
                            },
                        };
                        return [4, responseData];
                    case 4: return [2, _b.sent()];
                    case 5: return [2];
                }
            });
        });
    };
    ITGExecutionTransformation.prototype.validateServiceResponse = function (data) {
        if ((data && data.errorCode) ||
            (data && data.status === common_1.HTTP_SUCCESS_MESSAGE && data.errorMessages && data.errorMessages.length)) {
            var responseData = {
                messages: data.errorMessages,
                statusCode: data.errorCode,
            };
            return responseData;
        }
    };
    ITGExecutionTransformation.prototype.validateSdkRequest = function (request, templateRequest) {
        if (!request || !templateRequest || (templateRequest && !templateRequest.url)) {
            var responseData = {
                html: '',
                errors: [
                    {
                        statusCode: common_1.NULL_REQUEST,
                        messages: [common_1.NULL_REQUEST_MSG],
                    },
                ],
            };
            return responseData;
        }
    };
    ITGExecutionTransformation.prototype.transformEnDeCryptedField = function (request) {
        var _this = this;
        if (request && request.query) {
            var keys = Object.keys(request.query);
            keys.forEach(function (key) {
                var _a;
                if (request.query) {
                    var val = request.query[key];
                    if (val && typeof val === 'string') {
                        var splitVal = val.match('\\{(.*)\\}');
                        if (splitVal) {
                            var ciphertext = splitVal[1];
                            var encryptedVal = val.replace(splitVal[0], '');
                            var deCrypteddVal = _this.encryptAndDecrypt.enCryptDeCryptValue(encryptedVal, _this.serviceCallResponseData.sessionId, false);
                            if (ciphertext && ciphertext === 'cipher') {
                                if (!((_a = _this.config) === null || _a === void 0 ? void 0 : _a.isServiceProtected)) {
                                    request.query[key] = deCrypteddVal;
                                }
                                else {
                                    request.query[key] = encryptedVal;
                                }
                            }
                        }
                    }
                }
            });
        }
    };
    return ITGExecutionTransformation;
}(Transformation_1.Transformation));
exports.ITGExecutionTransformation = ITGExecutionTransformation;
//# sourceMappingURL=ItgExecutionTransformation.js.map